import 'jquery';

const mediaObjectCover = {

  init: function () {

    $('.media__object--cover').each(function() {

      const $mediaObject      = $(this),
            $mediaObjectImage = $mediaObject.find('img'),
            bgImage           = $mediaObjectImage.attr('src'),
            bgPosition        = $mediaObject.attr('data-bg-position') ? $mediaObject.attr('data-bg-position') : 'left  center',
            $mediaBody        = $mediaObject.siblings('.media__body');

      if(bgImage && bgPosition) {

        if($mediaObject.outerHeight() < $mediaBody.outerHeight()) {
          $mediaObject.outerHeight($mediaBody.outerHeight());
        }
        else {
          $mediaBody.outerHeight($mediaObject.outerHeight());
        }

        $mediaObject.css('background-image', `url(${ bgImage })`);
        $mediaObject.css('background-position', bgPosition);

      }

    });

  }

};

$(function() {

  mediaObjectCover.init();

});
